<template>
  <div>
    <br />
    <h2 class="ViewHeading">Location Management</h2>
    <div>
      <b-row
        ><b-col>
          <h4>{{ this.selectedlocation }}</h4>
        </b-col></b-row
      >

      <b-row> </b-row>
    </div>

    <b-card>
      <b-tabs v-model="LocationTabs" lazy active>
        <b-tab lazy title="Location Contacts" id="LocationContactTab">
          <EstateContractors></EstateContractors>
        </b-tab>
        <b-tab lazy title="Location Groups" id="SubGroupsTab">
          <b-card>
            <b-row
              ><b-col cols="12" class="text-right"
                ><b-button variant="outline-info" v-on:click="refreshView()"
                  ><BIconArrowClockwise></BIconArrowClockwise></b-button></b-col
            ></b-row>
            <b-card
              border-variant="light"
              v-if="this.SubGroupArray.length == 0"
            >
              <b-card-body class="text-center">
                <h5>No Location Groups set for this location</h5>
              </b-card-body>
            </b-card>
            <b-row
              ><b-col><br /></b-col
            ></b-row>
            <b-card-group
              deck
              v-if="this.SubGroupArray.length != 0 && screenWidth < 1000"
            >
              <!-- START OF CARD -->
              <b-card
                v-for="(id, idx) in SubGroupArray"
                :key="idx"
                border-variant="secondary"
                align="center"
                header-bg-variant="light"
                header-text-variant="dark"
                footer-tag="footer"
                style="width: 100%; margin-bottom: 1rem"
              >
                <template #footer>
                  <b-button
                    block
                    variant="light"
                    @click="showdetails(id.SubgroupName, id)"
                    >Details</b-button
                  >
                </template>
                <template #header>
                  <b-row
                    ><b-col class="text-center">{{
                      id.SubgroupName
                    }}</b-col></b-row
                  >
                  <b-row
                    ><b-col
                      ><BIconArrowUpRightSquare
                        font-scale="1.5"
                        v-b-tooltip.hover
                        title="Trending Up"
                        v-if="id.GroupTrend == 'UP'"
                      ></BIconArrowUpRightSquare>
                      <BIconArrowDownRightSquare
                        font-scale="1.5"
                        v-b-tooltip.hover
                        title="Trending Down"
                        v-if="id.GroupTrend == 'DOWN'"
                      ></BIconArrowDownRightSquare>
                      <BIconDashSquare
                        font-scale="1.5"
                        v-b-tooltip.hover
                        title="Stable"
                        v-if="id.GroupTrend == 'STABLE'"
                      ></BIconDashSquare
                    ></b-col>
                  </b-row>
                </template>
                <b-row no-gutters
                  ><b-button
                    size="sm"
                    variant="outline-info"
                    block
                    v-on:click="goTo('Notifications')"
                    >Notifications
                    <b-badge variant="info">{{
                      id.NotificationCount
                    }}</b-badge></b-button
                  ></b-row
                >

                <b-row no-gutters
                  ><b-button
                    variant="outline-secondary"
                    size="sm"
                    block
                    v-on:click="goTo('Endpoints', 2)"
                    >EndPoints
                    <b-badge variant="secondary">{{
                      id.EndpointCount
                    }}</b-badge></b-button
                  ></b-row
                >

                <b-row no-gutters
                  ><b-button
                    variant="outline-secondary"
                    block
                    size="sm"
                    v-on:click="goTo('Devices', 0)"
                    >Devices
                    <b-badge variant="secondary">{{
                      id.DeviceCount
                    }}</b-badge></b-button
                  ></b-row
                >
                <b-row no-gutters
                  ><b-button
                    variant="outline-secondary"
                    block
                    size="sm"
                    v-on:click="goTo('Status')"
                    ><b-avatar-group
                      ><b-avatar rounded variant="danger">{{
                        id.GroupCountExtreme
                      }}</b-avatar
                      ><b-avatar rounded class="highrisk">{{
                        id.GroupCountHigh
                      }}</b-avatar
                      ><b-avatar rounded variant="warning">{{
                        id.GroupCountModerate
                      }}</b-avatar
                      ><b-avatar rounded variant="success">{{
                        id.GroupCountLow
                      }}</b-avatar></b-avatar-group
                    ></b-button
                  ></b-row
                >
              </b-card>
            </b-card-group>
            <b-card-group
              deck
              v-if="this.SubGroupArray.length != 0 && screenWidth >= 1000"
            >
              <!-- START OF CARD -->
              <b-card
                v-for="(id, idx) in SubGroupArray"
                :key="idx"
                border-variant="secondary"
                align="center"
                header-bg-variant="light"
                header-text-variant="dark"
                footer-tag="footer"
                style="min-width: 22%; max-width: 22%; margin-bottom: 1rem"
              >
                <template #footer>
                  <b-button
                    block
                    variant="light"
                    @click="showdetails(id.SubgroupName, id)"
                    >Details</b-button
                  >
                </template>
                <template #header>
                  <b-row
                    ><b-col class="text-center">{{
                      id.SubgroupName
                    }}</b-col></b-row
                  >
                  <b-row
                    ><b-col
                      ><BIconArrowUpRightSquare
                        font-scale="1.5"
                        v-b-tooltip.hover
                        title="Trending Up"
                        v-if="id.GroupTrend == 'UP'"
                      ></BIconArrowUpRightSquare>
                      <BIconArrowDownRightSquare
                        font-scale="1.5"
                        v-b-tooltip.hover
                        title="Trending Down"
                        v-if="id.GroupTrend == 'DOWN'"
                      ></BIconArrowDownRightSquare>
                      <BIconDashSquare
                        font-scale="1.5"
                        v-b-tooltip.hover
                        title="Stable"
                        v-if="id.GroupTrend == 'STABLE'"
                      ></BIconDashSquare
                    ></b-col>
                  </b-row>
                </template>
                <b-row no-gutters
                  ><b-button
                    size="sm"
                    variant="outline-info"
                    block
                    v-on:click="goTo('Notifications')"
                    >Notifications
                    <b-badge variant="info">{{
                      id.NotificationCount
                    }}</b-badge></b-button
                  ></b-row
                >

                <b-row no-gutters
                  ><b-button
                    variant="outline-secondary"
                    size="sm"
                    block
                    v-on:click="goTo('Endpoints', 2)"
                    >EndPoints
                    <b-badge variant="secondary">{{
                      id.EndpointCount
                    }}</b-badge></b-button
                  ></b-row
                >

                <b-row no-gutters
                  ><b-button
                    variant="outline-secondary"
                    block
                    size="sm"
                    v-on:click="goTo('Devices', 0)"
                    >Devices
                    <b-badge variant="secondary">{{
                      id.DeviceCount
                    }}</b-badge></b-button
                  ></b-row
                >
                <b-row no-gutters
                  ><b-button
                    variant="outline-secondary"
                    block
                    size="sm"
                    v-on:click="goTo('Status')"
                    ><b-avatar-group
                      ><b-avatar rounded variant="danger">{{
                        id.GroupCountExtreme
                      }}</b-avatar
                      ><b-avatar rounded class="highrisk">{{
                        id.GroupCountHigh
                      }}</b-avatar
                      ><b-avatar rounded variant="warning">{{
                        id.GroupCountModerate
                      }}</b-avatar
                      ><b-avatar rounded variant="success">{{
                        id.GroupCountLow
                      }}</b-avatar></b-avatar-group
                    ></b-button
                  ></b-row
                >
              </b-card>
            </b-card-group>
            <b-row
              ><b-col><br /></b-col
            ></b-row>
          </b-card>
        </b-tab>
        <b-tab lazy title="Location Group Management" id="SubGroupsTab">
          <LocationGroupManagement></LocationGroupManagement>
        </b-tab>
        <b-tab lazy title="Location Group Devices" id="SubGroupsTab">
          <LocationGroupDeviceManagement></LocationGroupDeviceManagement>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-modal
      ref="LocationDetailsModal"
      id="LocationDetailsModal"
      :title="subhead"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
    >
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <b-row>
        <b-col
          ><b-button
            v-b-toggle.DeviceCollapse
            variant="outline-secondary"
            block
          >
            Device Details
            <b-badge variant="secondary">{{ this.DeviceCounts }}</b-badge>
          </b-button></b-col
        >
        <b-col
          ><b-button
            v-b-toggle.EndpointCollapse
            variant="outline-secondary"
            block
            >Endpoint Details
            <b-badge variant="secondary">{{
              this.OutletCounts
            }}</b-badge></b-button
          ></b-col
        >
      </b-row>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <b-row>
        <b-col
          ><b-button variant="outline-info" href="/AlertsOverview" block>
            Notifications
            <b-badge variant="info">{{ this.NotificationCounts }}</b-badge>
          </b-button></b-col
        >
        <b-col
          ><b-button
            variant="outline-info"
            v-on:click="DataDetailsView(subhead, 'Subgroup')"
            block
            >Group Details</b-button
          ></b-col
        >
      </b-row>

      <b-collapse id="DeviceCollapse" class="mt-2">
        <b-card
          header-bg-variant="light"
          align="center"
          border-variant="info"
          header-text-variant="secondary"
          style="max-height: 280px; overflow: scroll;"
          header="Devices"
        >
          <b-card
            v-if="
              C1DeviceData.length == 0 &&
                O1DeviceData.length == 0 &&
                HWDeviceData.length == 0
            "
          >
            <p>No Devices Currently in Location Group</p>
          </b-card>
          <b-table
            v-if="C1DeviceData.length != 0"
            sticky-header
            id="C1Table"
            :items="C1DeviceData"
            no-border-collapse
            hover
            show-empty
            empty-text="You currently dont have any Assets of this type"
            responsive
            small
          >
            <template #thead-top>
              <b-tr>
                <b-th variant="primary" colspan="2">Clarence C-1</b-th>
                <b-th
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    v-on:click="viewDevices('C-1')"
                    >View</b-button
                  ></b-th
                >
              </b-tr>
            </template>
            <template v-slot:cell(Status)="{ item }">
              <b-badge v-if="item.Status == 'L'" pill variant="success">Low</b-badge>
              <b-badge v-if="item.Status == 'M'" pill variant="warning">Moderate</b-badge>
              <b-badge v-if="item.Status == 'H'" pill class="highrisk">High</b-badge>
              <b-badge v-if="item.Status == 'E'" pill variant="danger">Extremely High</b-badge>
            </template>
          </b-table>
          <b-table
            v-if="O1DeviceData.length != 0"
            sticky-header
            id="O1Table"
            :items="O1DeviceData"
            no-border-collapse
            hover
            show-empty
            empty-text="You currently dont have any Assets of this type"
            responsive
            small
          >
            <template #thead-top>
              <b-tr>
                <b-th variant="primary" colspan="2">Clarence O-1</b-th>
                <b-th
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    v-on:click="viewDevices('O-1')"
                    >View</b-button
                  ></b-th
                >
              </b-tr>
            </template>
            <template v-slot:cell(Status)="{ item }">
              <b-badge v-if="item.Status == 'L'" pill variant="success">Low</b-badge>
              <b-badge v-if="item.Status == 'M'" pill variant="warning">Moderate</b-badge>
              <b-badge v-if="item.Status == 'H'" pill class="highrisk">High</b-badge>
              <b-badge v-if="item.Status == 'E'" pill variant="danger">Extremely High</b-badge>
            </template>
          </b-table>
            <b-table
            v-if="RouterData.length != 0"
            sticky-header
            id="RouterTable"
            :items="RouterData"
            no-border-collapse
            hover
            show-empty
            empty-text="You currently dont have any Assets of this type"
            responsive
            small
          >
            <template #thead-top>
              <b-tr>
                <b-th variant="primary" colspan="2">Routers</b-th>
                <b-th
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    v-on:click="viewDevices('Router')"
                    >View</b-button
                  ></b-th
                >
              </b-tr>
            </template>
            <template v-slot:cell(Status)="{ item }">
              <b-badge v-if="item.Status == ''" pill variant="secondary">N/A</b-badge>
            </template>
          </b-table>
          <b-table
            v-if="HWDeviceData.length != 0"
            sticky-header
            id="HWTable"
            :items="HWDeviceData"
            no-border-collapse
            hover
            show-empty
            empty-text="You currently do not have any AG Washbasin Units"
            responsive
            small
          >
            <template #thead-top>
              <b-tr>
                <b-th variant="primary" colspan="2">Washbasins</b-th>
                <b-th
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    v-on:click="viewDevices('HW')"
                    >View</b-button
                  ></b-th
                >
              </b-tr>
            </template>
            <template v-slot:cell(Status)="{ item }">
              <b-badge v-if="item.Status == 'L'" pill variant="success">Low</b-badge>
              <b-badge v-if="item.Status == 'M'" pill variant="warning">Moderate</b-badge>
              <b-badge v-if="item.Status == 'H'" pill class="highrisk">High</b-badge>
              <b-badge v-if="item.Status == 'E'" pill variant="danger">Extremely High</b-badge>
            </template>
          </b-table>
        </b-card>
      </b-collapse>
      <b-collapse id="EndpointCollapse" class="mt-2">
        <b-card
          header-bg-variant="light"
          align="center"
          border-variant="info"
          header-text-variant="secondary"
          style="max-height: 280px; overflow: scroll;"
          header="Endpoints"
        >
          <b-card v-if="TapData.length == 0 && ShowerData.length == 0">
            <p>No Outlets Currently in Location Group</p>
          </b-card>
          <b-table
            v-if="TapData.length != 0"
            sticky-header
            id="TapTable"
            :items="TapData"
            no-border-collapse
            hover
            show-empty
            empty-text="You currently dont have any Assets of this type"
            responsive
            small
          >
            <template #thead-top>
              <b-tr>
                <b-th variant="primary" colspan="2">Taps</b-th>
                <b-th
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    v-on:click="viewDevices('Taps')"
                    >View Devices</b-button
                  ></b-th
                >
              </b-tr>
            </template>
            <template v-slot:cell(Sentinel)="{ item }">
              <p v-if="item == 'FALSE'"></p>
            </template>
          </b-table>
          <b-table
            v-if="ShowerData.length != 0"
            sticky-header
            id="ShowerTable"
            :items="ShowerData"
            :fields="testfields"
            no-border-collapse
            hover
            show-empty
            empty-text="You currently dont have any Assets of this type"
            responsive
            small
          >
            <template #thead-top>
              <b-tr>
                <b-th variant="primary" colspan="2">Showers</b-th>
                <b-th
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    v-on:click="viewDevices('Showers')"
                    >View Devices</b-button
                  ></b-th
                >
              </b-tr>
            </template>
          </b-table>
        </b-card>
      </b-collapse>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
    </b-modal>

    <b-modal
      ref="DetailsModal"
      id="DetailsModal"
      title="Details"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
    >
      <DetailsData></DetailsData>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import {} from "bootstrap-vue";
import {
  BIconArrowDownRightSquare,
  BIconArrowUpRightSquare,
  BIconDashSquare,
  BIconArrowClockwise,
} from "bootstrap-vue";
import DetailsData from "../components/DetailData.vue";
import LocationGroupManagement from "../views/Subgroups.vue";
import LocationGroupDeviceManagement from "../views/DeviceSubgroupManagement.vue";
import EstateContractors from "../components/EstateContractor.vue";
import Vue from "vue";

export default {
  computed: {},
  components: {
    BIconArrowDownRightSquare,
    BIconArrowUpRightSquare,
    BIconDashSquare,
    BIconArrowClockwise,
    DetailsData,
    LocationGroupManagement,
    LocationGroupDeviceManagement,
    EstateContractors,
  },

  data() {
    return {
      SubGroupArray: [],
      response: null,
      modal: false,
      subhead: "",
      trenddirection: "",
      GroupCountExtreme: "",
      GroupCountHigh: "",
      GroupCountModerate: "",
      GroupCountLow: "",
      selectedlocation: localStorage.getItem("CurrentLocation"),
      LocationTabs: 0,
      O1DeviceData: [],
      C1DeviceData: [],
      HWDeviceData: [],
      RouterData: [],
      TapData: [],
      DeviceCounts: "",
      OutletCounts: "",
      NotificationCounts: "",
      ShowerData: [],
      screenWidth: 0,
    };
  },

  beforeMount() {},

  mounted() {
    this.updateScreenWidth();
    this.onScreenResize();
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "LocationSubgroup",
      LocationDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        let SubGroupData = response.data.Values;
        for (let i = 0; i < SubGroupData.length; i++) {
          this.SubGroupArray.push({
            id: "",
            SubgroupName: SubGroupData[i][0],
            Level1Name: SubGroupData[i][1],
            Level2Name: SubGroupData[i][2],
            Level3Name: SubGroupData[i][3],
            DeviceCount: SubGroupData[i][4],
            EndpointCount: SubGroupData[i][5],
            NotificationCount: SubGroupData[i][6],
            GroupCountExtreme: SubGroupData[i][7].ExtremelyHighRisk,
            GroupCountHigh: SubGroupData[i][7].HighRisk,
            GroupCountModerate: SubGroupData[i][7].ModerateRisk,
            GroupCountLow: SubGroupData[i][7].LowRisk,
            GroupTrend: SubGroupData[i][8],
          });
        }
      });
  },

  methods: {
    onScreenResize() {
      window.addEventListener("resize", () => {
        this.updateScreenWidth();
      });
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    getUserInitials() {
      this.userInitials = localStorage.getItem("UserInitials");
      return this.userInitials;
    },
    userfullname() {
      this.userfullname = localStorage.getItem("fullname");
      return this.userfullname;
    },

    showdetails(value, data) {
      data;
      this.subhead = "";
      this.subhead = value;

      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locations";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "SubgroupDetail",
        LocationDict: [
          {
            Location: this.selectedlocation,
            SubGroupName: this.subhead,
          },
        ],
      };

      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          let LocData = response.data.Values;
          let Showers = [];
          let C1Devices = [];
          let O1Devices = [];
          let HWDevices = [];
          let Routers = [];
          let Taps = [];
          for (let i = 0; i < LocData.length; i++) {
            if (i != 4) {
              // Loop for dealing with devices
              for (let y = 0; y < LocData[i].length; y++) {
                if (i == 0) {
                  let C1RiskLevel = "";
                  if (LocData[i][y][2] < 150) {
                    C1RiskLevel = "E";
                  } else if (
                    (LocData[i][y][2] >= 150) &
                    (LocData[i][y][2] < 500)
                  ) {
                    C1RiskLevel = "H";
                  } else if (
                    (LocData[i][y][2] >= 500) &
                    (LocData[i][y][2] < 850)
                  ) {
                    C1RiskLevel = "M";
                  } else if (LocData[i][y][2] >= 850) {
                    C1RiskLevel = "L";
                  }
                  C1Devices.push({
                    ID: LocData[i][y][0],
                    Position: LocData[i][y][1],
                    Status: C1RiskLevel,
                  });
                }
                if (i == 1) {
                  let RiskLevel = "";
                  if (LocData[i][y][2] < 150) {
                    RiskLevel = "E";
                  } else if (
                    (LocData[i][y][2] >= 150) &
                    (LocData[i][y][2] < 500)
                  ) {
                    RiskLevel = "H";
                  } else if (
                    (LocData[i][y][2] >= 500) &
                    (LocData[i][y][2] < 850)
                  ) {
                    RiskLevel = "M";
                  } else if (LocData[i][y][2] >= 850) {
                    RiskLevel = "L";
                  }
                  O1Devices.push({
                    ID: LocData[i][y][0],
                    Position: LocData[i][y][1],
                    Status: RiskLevel,
                  });
                }
                if (i == 2) {
                  HWDevices.push({
                    ID: "",
                  });
                }
                if(i == 3){

                  Routers.push({
                    ID: LocData[i][y][0],
                    Position: LocData[i][y][1],
                    Status: "" ,
                  })
                }
              }
            } else {
              // Loop for dealing with endpoints
              if (LocData[i]["Cold Tap"] != null) {
                for (let x = 0; x < LocData[i]["Cold Tap"].length; x++) {
                  Taps.push({
                    ID: LocData[i]["Cold Tap"][x][0],
                    DeptFloor: LocData[i]["Cold Tap"][x][1],
                    Sentinel: LocData[i]["Cold Tap"][x][2],
                  });
                }
              }
              if (LocData[i]["Mixed Tap"] != null) {
                for (let z = 0; z < LocData[i]["Mixed Tap"].length; z++) {
                  Taps.push({
                    ID: LocData[i]["Mixed Tap"][z][0],
                    DeptFloor: LocData[i]["Mixed Tap"][z][1],
                    Sentinel: LocData[i]["Mixed Tap"][z][2],
                  });
                }
              }
              if (LocData[i]["Hot Tap"] != null) {
                for (let z = 0; z < LocData[i]["Hot Tap"].length; z++) {
                  Taps.push({
                    ID: LocData[i]["Hot Tap"][z][0],
                    DeptFloor: LocData[i]["Hot Tap"][z][1],
                    Sentinel: LocData[i]["Hot Tap"][z][2],
                  });
                }
              }
            }

            this.O1DeviceData = O1Devices;
            this.C1DeviceData = C1Devices;
            this.HWDeviceData = HWDevices;
            this.RouterData = Routers;
            this.TapData = Taps;
            this.ShowerData = Showers;
            this.DeviceCounts = data.DeviceCount;
            this.OutletCounts = data.EndpointCount;
            this.NotificationCounts = data.NotificationCount;
          }

          this.$refs["LocationDetailsModal"].show(
            this.subhead,
            this.DeviceCounts,
            this.NotificationCounts,
            this.OutletCounts
          );
        });
    },

    DataDetailsView(ID, Type) {
      Vue.prototype.$DeviceID = ID;
      Vue.prototype.$DetailToShow = Type;
      this.$refs["DetailsModal"].show();
    },
    viewDevices(value) {
      if (value == "C-1") {
        Vue.prototype.$tab = 0;
        this.$router.push("/Dashboard");
      }
      if (value == "O-1") {
        Vue.prototype.$tab = 1;
        this.$router.push("/Dashboard");
      }
      if (value == 'Router'){
        Vue.prototype.$tab = 2;
        this.$router.push("/DevicesAndOutlets");
      }
      if (value == "Taps") {
        Vue.prototype.$tab = 2;
        this.$router.push("/DevicesAndOutlets");
      }
    },

    refreshView() {
      this.SubGroupArray = [];
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locations";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "LocationSubgroup",
        LocationDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };

      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          let SubGroupData = response.data.Values;
          for (let i = 0; i < SubGroupData.length; i++) {
            this.SubGroupArray.push({
              id: "",
              SubgroupName: SubGroupData[i][0],
              Level1Name: SubGroupData[i][1],
              Level2Name: SubGroupData[i][2],
              Level3Name: SubGroupData[i][3],
              DeviceCount: SubGroupData[i][4],
              EndpointCount: SubGroupData[i][5],
              NotificationCount: SubGroupData[i][6],
              GroupCountExtreme: SubGroupData[i][7].ExtremelyHighRisk,
              GroupCountHigh: SubGroupData[i][7].HighRisk,
              GroupCountModerate: SubGroupData[i][7].ModerateRisk,
              GroupCountLow: SubGroupData[i][7].LowRisk,
              GroupTrend: SubGroupData[i][8],
            });
          }
        });
    },

    goTo(Location, tab) {
      if (Location == "AGWashbasinUnits") {
        this.$router.push("/WashbasinDashboard");
      } else if (Location == "Notifications") {
        this.$router.push("/AlertsOverview");
      } else if (Location == "Endpoints") {
        Vue.prototype.$tab = tab;
        this.$router.push("/DevicesAndOutlets");
      } else if (Location == "Devices") {
        Vue.prototype.$tab = tab;
        this.$router.push("/DevicesAndOutlets");
      } else if (Location == "Status") {
        this.$router.push("/Dashboard");
      }
    },
  },
};
</script>

<style>
input[type="text"],
select {
  width: 100%;
}

#cancel-label {
  color: white;
  font-size: large;
}

.Upload label {
  font-size: 15px;
}

p.cardhead {
  color: gray;
  font-size: medium;
  margin-bottom: 0;
}

p.cardbody {
  color: black;
  font-size: medium;
  margin: 0.25rem;
}

.cardcol {
  border: solid lightgray;
}

.devicerow {
  border: solid lightgray;
  margin-left: 2px;
  margin-right: 2px;
}

.devicecol {
  padding: 0;
  margin-top: 0.5rem;
}

.right {
  float: right;
}

.left {
  float: left;
}
.centre {
  text-align: center;
}
.modalhead {
  color: white;
}
.DetailsRowHeader {
  background-color: #6c757d;
  color: white;
  margin: 1px;
}

#ButtonRow {
  padding-bottom: 1.5rem;
  border-bottom: solid 2px gray;
  margin-left: 3rem;
  margin-right: 3rem;
}
p.tiny {
  font-size: 10px;
  font-weight: bold;
  color: grey;
}
.b-avatar-group .b-avatar-group-inner {
  display: block;
}

#Table {
  margin: auto;
  text-align: center;
}

#cancel-label {
  color: white;
  font-size: large;
}

.Upload label {
  font-size: 15px;
}

.modal {
  text-align: center;
}

.test {
  float: right;
}
</style>
